import {pianoEnabled} from './affiliate_settings';

// this code came from https://docs.piano.io/enabling-ad-block-detection/?paragraphId=b8e31e9f389e430
// and https://jira.advance.net/browse/PIANO-1
const load = pianoEnabled ? () => {
    const setNptTechAdblockerCookieFunction = (adblocker) => {
        const d = new Date();
        d.setTime(d.getTime() + 172800000);
        document.cookie = `__adblocker=${adblocker ? "true" : "false"}; expires=${d.toUTCString()}; path=/`;
    };

    document.cookie = "__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    const script = document.createElement("script");
    script.setAttribute("async", true);
    script.setAttribute("src", "//www.npttech.com/advertising.js");
    script.onerror = () => setNptTechAdblockerCookieFunction(true);
    document.getElementsByTagName("head")[0].appendChild(script);
} : () => {};

export default load;
